































import {
  defineComponent,
  PropType,
  computed,
  ref,
} from '@nuxtjs/composition-api';
import Accordion from '@/components/Accordion/Accordion.vue';

export interface ISection {
  iconClasses?: string;
  icon?: string;
  headerText: string;
  bodyText: string;
  boldHeader?: boolean;
  img: string;
  isExpanded?: boolean;
}

export default defineComponent({
  components: {
    Accordion,
  },
  props: {
    sectionList: {
      type: Array as PropType<ISection[]>,
      required: true,
    },
    isFullWidth: {
      type: Boolean,
      default: true,
    },
    variant: {
      type: String,
      default: 'lavender',
    },
  },
  setup(props, { emit }) {
    const currentSection = ref(0);
    // We are creating a copy of the props.sectionList since this component is used in Builder and we don't have access to the
    // page level to be able to update the props on click. Instead, we create a copy and take action upon the copy in this component
    const sectionsCopy = computed(() => [...props.sectionList]);

    const currentImage = computed(() => {
      return sectionsCopy.value[currentSection.value]?.img;
    });

    const handleToggleExpandedState = (selection) => {
      const selectedSection = sectionsCopy.value.find(
        (b) => b.bodyText === selection.text
      );

      currentSection.value = selectedSection
        ? sectionsCopy.value.indexOf(selectedSection)
        : 0;

      sectionsCopy.value.forEach((section, index) => {
        if (index !== currentSection.value) {
          section.isExpanded = false;
        }
      });
      sectionsCopy.value[currentSection.value].isExpanded =
        !sectionsCopy.value[currentSection.value].isExpanded;
      emit('toggleExpandedState', selectedSection);
    };

    return {
      handleToggleExpandedState,
      currentSection,
      currentImage,
      sectionsCopy,
    };
  },
});
